import * as React from 'react';
import ReactGA from 'react-ga';
import { useSelector } from 'react-redux';
import { HeaderSection } from './HeaderSection';
import { ProductSection } from './ProductSection';
import { ReferencesSection } from './ReferencesSection';
import { AbonnementsSection } from './AbonnementsSection';
import { AbonnementsSectionJanitor } from './AbonnementsSectionJanitor';

import { FAQsSection } from './FAQsSection';
import { State } from '../../reducers';
import { AccountCategory, Feature } from '@api/v1';

export const StarterPage: React.FC = (): JSX.Element => {
	ReactGA.pageview(window.location.pathname + window.location.search);
	const { category } = useSelector((state: State) => state.registration);
	const { features } = useSelector((state: State) => state.acl);
	const isJanitorNewPricing =
		category === AccountCategory.FACILITY_MANAGEMENT &&
		features.includes(Feature.JanitorNewPricing);

	return (
		<>
			<HeaderSection isJanitorNewPricing={isJanitorNewPricing} />
			<ProductSection isJanitor={isJanitorNewPricing} />
			<ReferencesSection />
			{!isJanitorNewPricing && <AbonnementsSection />}
			{isJanitorNewPricing && <AbonnementsSectionJanitor />}
			<FAQsSection />
		</>
	);
};
